import { render, staticRenderFns } from "./LayoutCompactPreview.vue?vue&type=template&id=2cb2356a&"
import script from "./LayoutCompactPreview.vue?vue&type=script&lang=ts&"
export * from "./LayoutCompactPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports